import UserInterfacePlusCircleOutline from '@mds/icons/PlusCircle';
import {
    Button,
    Menu,
    MenuItem,
    Stack,
    Stack as ToolbarButtonGroup,
    TextField as ToolbarInput,
} from '@mui/material';
import { Option, Select } from 'components/ui/FormControls';
import React, { Fragment, useState } from 'react';

import {
    ChannelSubscriberKind,
    freeClosedChannelSubscriberLabel,
    freeOpenChannelSubscriberLabel,
    premiumChannelSubscriberLabel,
} from '../../../shared/global-enums';
import { ChannelTypes } from '../../../shared/types';

import { Stack as Toolbar } from '@mui/material';

function toOptions(
    map: Partial<{ [x in ChannelSubscriberKind]: string }>
): Option[] {
    return Object.keys(map)
        .map((k) => k as ChannelSubscriberKind)
        .map((k) => ({
            label: map[k] || '',
            value: k,
        }));
}

export interface ChannelSubscribersFilterProps {
    channelType: ChannelTypes;
    searchString: string;
    channelSubscriberKind: ChannelSubscriberKind;
    onQueryStringChange: (value: string) => void;
    onSelectedKindChange: (value: ChannelSubscriberKind) => void;
    onAddNewSubscriber: () => void;
    onAddBulkNewSubscribers: () => void;
}

export const ChannelSubscribersFilter = (
    props: ChannelSubscribersFilterProps
) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const options = toOptions(
        props.channelType === ChannelTypes.premium
            ? premiumChannelSubscriberLabel
            : props.channelType === ChannelTypes.freeClosed
              ? freeClosedChannelSubscriberLabel
              : freeOpenChannelSubscriberLabel
    );

    const handleRangeChange = (selected: Option) => {
        props.onSelectedKindChange(selected.value as ChannelSubscriberKind);
    };

    const handleAddSubscribersChange = (value: string | number) => {
        setAnchorEl(null);
        if (value === 'bulk') return props.onAddBulkNewSubscribers();
        return props.onAddNewSubscriber();
    };

    return (
        <Fragment>
            <Stack
                direction="row"
                sx={{
                    justifyContent: 'space-between',
                }}
            >
                <Select
                    size="medium"
                    clearable={false}
                    menuPlacement="auto"
                    searchable={false}
                    sx={{ minWidth: 10, width: 284 }}
                    value={options.find(
                        (o) => o.value === props.channelSubscriberKind
                    )}
                    onChange={(opt: Option): void => handleRangeChange(opt)}
                    options={options}
                />
                <Stack
                    direction="row"
                    sx={{
                        gap: 1,
                    }}
                >
                    <Toolbar id="channel-subscribers-toolbar">
                        <ToolbarButtonGroup>
                            <ToolbarInput
                                id="channel-subscriber-toolbar-search"
                                placeholder="Type to search..."
                                onChange={(event) =>
                                    props.onQueryStringChange(
                                        event.target.value
                                    )
                                }
                                value={props.searchString}
                                size="small"
                            />
                            <Button
                                variant="outlined"
                                color="secondary"
                                startIcon={<UserInterfacePlusCircleOutline />}
                                onClick={(event) =>
                                    setAnchorEl(event.currentTarget)
                                }
                            >
                                Add subscribers
                            </Button>
                            <Menu
                                anchorEl={anchorEl}
                                open={!!anchorEl}
                                onClose={() => setAnchorEl(null)}
                            >
                                <MenuItem
                                    onClick={() =>
                                        handleAddSubscribersChange('manual')
                                    }
                                >
                                    Add manually
                                </MenuItem>
                                <MenuItem
                                    onClick={() =>
                                        handleAddSubscribersChange('bulk')
                                    }
                                >
                                    Upload CSV
                                </MenuItem>
                            </Menu>
                        </ToolbarButtonGroup>
                    </Toolbar>
                </Stack>
            </Stack>
        </Fragment>
    );
};
